/**
 * Visible Terms and Privacy links (Pretplata and Profil). The documents live on lukaaji.com.
 */
import { useLanguage } from '@/store';
import { cn, getAppPageTranslation } from '@/utils';
import { legalUrl } from '@/utils/legal';

interface LegalLinksProps {
  className?: string;
}

export function LegalLinks({ className }: LegalLinksProps) {
  const language = useLanguage();
  const links = [
    { href: legalUrl('terms', language), label: getAppPageTranslation('termsOfService', language) },
    { href: legalUrl('privacy', language), label: getAppPageTranslation('privacyPolicy', language) },
  ];

  return (
    <ul className={cn('flex flex-wrap items-center justify-center gap-x-6 text-sm', className)}>
      {links.map((link) => (
        <li key={link.href}>
          <a
            href={link.href}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex min-h-11 items-center text-muted-foreground underline-offset-4 hover:text-foreground hover:underline"
          >
            {link.label}
          </a>
        </li>
      ))}
    </ul>
  );
}
